import { render, staticRenderFns } from "./TableBicolor.vue?vue&type=template&id=3dee4728&scoped=true&"
import script from "./TableBicolor.vue?vue&type=script&lang=js&"
export * from "./TableBicolor.vue?vue&type=script&lang=js&"
import style0 from "./TableBicolor.vue?vue&type=style&index=0&id=3dee4728&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dee4728",
  null
  
)

export default component.exports